module.exports = __webpack_public_path__ + "static/media/aula.9230cfa8.svg";